import type { SYSAction } from "../../../../../../../_ovlclient/src"
import type { HookScreenNavigateIn_ReturnType } from "../../../../../../../_ovlclient/src/global/hooks"
import { FormInit } from "../../../../../../../_ovlclient/src/library/forms/formapi"

import { NewServiceStep2FormFieldsDef } from "../../../features/svl/svlnewservicestep2/formdef"

const HookScreenNavigateIn: SYSAction<any> = async (_, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  await FormInit("SVLNewServiceStep2", NewServiceStep2FormFieldsDef, {
    doFormChangedForEveryFieldInInit: false,
  })
}

export let hooks = { HookScreenNavigateIn }
